export default __webpack_public_path__ + "static/media/mp3.9b4d07cb.svg";